import { GET, ACCESS_TOKEN, POST } from "../comman/constants";
import { apiCall } from "../comman/connect";
import {
  GET_SEARCH_HISTORY_FAILURE,
  GET_SEARCH_HISTORY_SUCCESS,
  GET_SEARCH_HISTORY_REQUEST,
  RESET_SEARCH_HISTORY_SUCCESS,
} from "./actionConstants";
import {
  searchHistoryUserUrl,
  calculatorUrl,
  calculatoTablerUrl,
  calculatorCityurl,
  calculatorSuggestedData,
  calculatorCounterUrl,
  getFSIStatesUrl,
  getFSILocalBodyUrl,
  getFSIPropertyUrl,
  getFSIPlotAreaUrl,
  getFSIRoadUrl,
  getFSIInputDataUrl,
  getFSIZoneUrl,
  residualInsertionUrl
} from "../comman/urls";
import { _getStorageValue } from "../comman/localStorage";

const searchHistoryUserRequested = () => ({
  type: GET_SEARCH_HISTORY_REQUEST,
});

const searchHistoryUserSuccess = (data) => ({
  type: GET_SEARCH_HISTORY_SUCCESS,
  data,
});

const searchHistoryUserFailure = (data) => ({
  type: GET_SEARCH_HISTORY_FAILURE,
  data,
});

const searchHistoryUserReset = (data) => ({
  type: RESET_SEARCH_HISTORY_SUCCESS,
  data,
});

export const searchHistoryUser =
  (userId, reqId, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = searchHistoryUserUrl(userId, reqId);

    const onSuccess = (response) => {
      successHistorCallBack(response);
      dispatch(searchHistoryUserSuccess(response));
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
      dispatch(searchHistoryUserFailure(response));
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

export const getCalculatorState =
  (userId, query, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = calculatorUrl(userId, query);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

export const resetsearchHistoryUserUser = () => (dispatch) => {
  dispatch(searchHistoryUserReset());
};

export const getCalculatorTable =
  (userId, query, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());
    const url = calculatoTablerUrl(userId, query);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

 export const residualInsertion = (
  userId,
  query,
  payload,
  successHistorCallBack,
  failureHistoryCallBack
) => (dispatch) => {
  const url = residualInsertionUrl(userId, query);

   const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };


  _getStorageValue(ACCESS_TOKEN).then((token) => {
    if (token) {
      apiCall(POST, url, payload, onSuccess, onFailure, dispatch, token);
    }
  });
};

export const getCalculatorCity =
  (userId, successHistorCallBack, failureHistoryCallBack) => (dispatch) => {
    dispatch(searchHistoryUserRequested());
    const url = calculatorCityurl(userId);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

export const getCalculatorSuggested =
  (userId, city, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());
    const url = calculatorSuggestedData(userId, city);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };




  export const calculatorCounter =
  (userId, calculatorType, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {

    const url = calculatorCounterUrl(userId);
    const data  = {"module":calculatorType}


    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(POST, url, data, onSuccess, onFailure, dispatch, token);
      }
    });
  };


// FSI values
  export const getFSIZone =
  (userId,  successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());
    const url = getFSIZoneUrl(userId);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

//state
  export const getFSIState =
  (userId, data, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());
    const url = getFSIStatesUrl(userId,data);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };


  //localbody
    export const getFSILocal =
  (userId, state, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = getFSILocalBodyUrl(userId, state);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };


    //Propertyvalue
    export const getFSIProperty =
  (userId,data, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = getFSIPropertyUrl(userId,data);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

      //Plotvalue
    export const getFSIPlotArea =
  (userId, data, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = getFSIPlotAreaUrl(userId, data);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };

      //RoadValue
    export const getFSIPlotRoad =
  (userId, data, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = getFSIRoadUrl(userId, data);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };


    //RoadValue
    export const getFSIInputData =
  (userId, data, successHistorCallBack, failureHistoryCallBack) =>
  (dispatch) => {
    dispatch(searchHistoryUserRequested());

    const url = getFSIInputDataUrl(userId, data);

    const onSuccess = (response) => {
      successHistorCallBack(response);
    };

    const onFailure = (response) => {
      failureHistoryCallBack(response);
    };

    _getStorageValue(ACCESS_TOKEN).then((token) => {
      if (token !== undefined && token !== null) {
        apiCall(GET, url, "", onSuccess, onFailure, dispatch, token);
      }
    });
  };